import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import Modal from '../Modal';
import ModalHeader from '../ModalHeader';
import ExtendedLandlordInformationContent from '../ExtendedLandlordInformationContent';

import './ExtendedLandlordInformationModal.scss';

const noop = () => {};

const ExtendedLandlordInformationModal = ({
  landlordInformation,
  isOpen,
  onClose,
  renderContactContent = noop
}) => (
  <Modal
    size="medium"
    isOpen={isOpen}
    onRequestClose={onClose}
    contentLabel={trans('landlord_information.more')}
    testId="extendedLandlordInfoModal"
    ariaHideApp={false}
    className="modal-extended-landlord-information__container"
  >
    <ModalHeader className="modal-header__absolute" onRequestClose={onClose} />
    <ExtendedLandlordInformationContent
      type={landlordInformation.type}
      joiningDate={landlordInformation.firstListingDate}
      listingsPublished={landlordInformation.listingsPublished}
      numberOfBookingRequests={landlordInformation.numberOfBookingRequests}
      averageResponseTime={landlordInformation.averageResponseTime}
      languages={landlordInformation.languages}
      renderContactContent={renderContactContent}
    />
  </Modal>
);

ExtendedLandlordInformationModal.propTypes = {
  landlordInformation: PropTypes.shape({
    type: PropTypes.oneOf(['private', 'professional']).isRequired,
    firstListingDate: PropTypes.string.isRequired,
    listingsPublished: PropTypes.number.isRequired,
    averageResponseTime: PropTypes.string.isRequired,
    numberOfBookingRequests: PropTypes.number,
    languages: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  renderContactContent: PropTypes.func
};

export default ExtendedLandlordInformationModal;
